module.exports = new __parcel__URL__("righteousflash.eeb816eb.png").toString();